<template>
  <div class="sheet-container">
    <h2 class="sheet-title" v-if="title">
      {{ title }}
      <div class="sheet-title-right"><slot name="title-right" /></div>
    </h2>
    <div class="sheet-desc" v-show="desc">
      <span>{{ desc }}</span>
    </div>
    <div class="sheet-content">
      <slot />
    </div>
  </div>
</template>
<script>
export default {
  props: {
    title: {
      type: String,
      default: "标题",
    },
    desc: {
      type: String,
      default: "描述",
    },
  },
};
</script>
<style lang="less" scoped>
.sheet-container {
  font-family: 'HarmonyOS_Sans_SC';
  .sheet-title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 40px;
    margin-top: 0;
    margin-bottom: 16px;
    font-size: 32px;
    font-weight: 500;
    color: #333333;
    font-family: 'HarmonyOS_Sans_SC_Medium';
  }
  .sheet-desc {
    margin-bottom: 56px;
    font-size: 24px;
    font-weight: 400;
    color: #999999;
    line-height: 40px;
  }
}
</style>
<style lang="less">
.sheet-container {
  display: flex;
  flex-direction: column;
  height: 100%;
  position: relative;
  .sheet-content {
    flex: 1;
  }
  .sheet-list {
    display: flex;
    flex-wrap: wrap;
  }
  .sheet-item {
    margin-right: 32px;
    margin-bottom: 32px;
    display: flex;
    align-items: center;
    justify-content: center;

    box-sizing: border-box;
    width: 190px;
    height: 64px;
    font-size: 28px;
    font-weight: 400;
    color: #666;

    border-radius: 10px;
    border: 2px solid #cedcef;

    &.checked {
      background: #3583fb;
      color: #ffffff;
      border-color: #3583fb;
    }
    &.custom {
      color: #999999;
      &.customized {
        border-color: #2d89ff;
      }
    }
    &.remove {
      background: #f4f4f4;
      border-color: #f4f4f4;
      color: #b8b8b8;
      &.removable {
        background: #dceafe;
        border-color: #dceafe;
        color: #333333;
      }
    }
  }
}
</style>